import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  margin-bottom: 15px;
  height: 30px;
`;

export const SearchBar = styled.input`
  width: 100%;
  height: 30px;
  border-radius: 50px;
  padding-left: 12px;
  margin-right: 15px;
  outline: none;
  font-size: 14px;
  color: ${(props) => props.theme.colors.darkText};
  border: 1px solid ${(props) => props.theme.colors.border};
  background-color: ${(props) => props.theme.colors.secondaryContent};

  :hover {
    border-color: ${(props) => props.theme.colors.primary};
  }
`;
